import { userInfoHeight, userInfoWidth } from "@components/user-info/user-info";
import { useMediaQueryList } from "@hooks/use-media-query";
import { Box, Skeleton } from "@mui/material";
import { useMemo } from "react";

/** Number of rows to show in the left side */
const NUMBER_OF_ROWS = 4;

/**
 * A skeleton loader for the member profile page
 */
export function MemberProfileSkeleton(): JSX.Element {
  const { isScreenMdOrLarger, isScreenSm, isScreenXs } = useMediaQueryList();

  const infoBarHeight = useMemo(() => {
    if (isScreenMdOrLarger) {
      return "80px";
    }

    if (isScreenSm) {
      return "120px";
    }

    if (isScreenXs) {
      return "174px";
    }
  }, [isScreenMdOrLarger, isScreenSm, isScreenXs]);

  return (
    <Box component="div" sx={{ mt: "45px" }}>
      {/* Info bar */}
      <Skeleton variant="rectangular" width="100%" height={infoBarHeight} />

      {/* Content */}
      <Box
        component="div"
        sx={{
          display: "flex",
          flexFlow: isScreenMdOrLarger ? "row" : "column-reverse",
          alignItems: isScreenMdOrLarger ? "baseline" : "center",
          pt: isScreenMdOrLarger ? "15px" : "45px",
        }}
      >
        {/* Left side rows */}
        <Box component="div" width="100%">
          {[...Array(NUMBER_OF_ROWS)].map((_, index) => (
            <Box
              component="div"
              key={index}
              sx={{
                pt: "37px",
                pr: "20px",
              }}
            >
              <Skeleton variant="rectangular" height="54px" />
            </Box>
          ))}
        </Box>

        {/* Right side component */}
        <Skeleton
          variant="rectangular"
          width={userInfoWidth}
          height={userInfoHeight}
          sx={{
            minWidth: userInfoWidth,
          }}
        />
      </Box>
    </Box>
  );
}
